import CardWrapper from '../wrapper/card';
import DeleteFormModal from './modal/delete_form';
import { duplicateFormThunk } from '../../redux/thunks/form';
import { formatDateWithTime } from '../../helper';
import { FormObject } from '../../params/redux/form';
import ImageClass from '../../assets';
import { parseFormConfigData } from '../../helper/form_builder';
import ShareFormModal from './modal/share_form';
import { useParams } from 'react-router';
import { useState } from 'react';
import { AppDispatch, RootState } from '../../redux/store';
import { Avatar, Box, Divider, IconButton, Menu, MenuItem, Typography } from '@mui/material';
import { brand, green, orange, red } from '../../theme/themePrimitives';
import { DeleteOutline, EditOutlined, FilterNoneOutlined, MoreVert, ShareOutlined } from '@mui/icons-material';
import { settingCreateFormFlag, settingFormFieldObject, settingSelectedForm, settingSelectedFormFlag } from '../../redux/slices/form';
import { useDispatch, useSelector } from 'react-redux';

// eslint-disable-next-line complexity
const FormCardItemComponent = ({ form }: { form: FormObject }) => {
    const dispatch = useDispatch<AppDispatch>();
    const { id } = useParams();
    const [showDeleteModal, setShowDeleteModal] = useState<boolean>(false);
    const [showShareModal, setShowShareModal] = useState<boolean>(false);
    const { forms } = useSelector((state: RootState) => state.form);
    const { currentUser } = useSelector((state: RootState) => state.app);
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

    const handleDeleteForm = () => {
        const selectedForm = forms.find((item: FormObject) => item.id === form.id);
        dispatch(settingSelectedForm(selectedForm));
        setShowDeleteModal(true);
    };

    const handleDuplicateForm = async () => {
        try {
            await dispatch(duplicateFormThunk({ form_id: form.id, client_id: id ? parseInt(id as string, 10) : 0 })).unwrap();
        } catch (e) {
            // catch errors
        }
    };

    const handleShareForm = () => {
        const selectedForm = forms.find((item: FormObject) => item.id === form.id);
        dispatch(settingSelectedForm(selectedForm));
        setShowShareModal(true);
    };

    const editFormHandler = async () => {
        const selectedForm = forms.find((item: FormObject) => item.id === form.id);
        const formField = await parseFormConfigData(selectedForm as FormObject);
        dispatch(settingSelectedForm(selectedForm));
        dispatch(settingFormFieldObject(formField));
        dispatch(settingCreateFormFlag(true));
    };

    const onClickFormDetail = () => {
        dispatch(settingSelectedForm(form));
        dispatch(settingSelectedFormFlag(true));
    };

    return <CardWrapper>
        <Box display="flex" justifyContent="space-between" alignItems="center">
            <Box
                marginY="14px"
                bgcolor={form.status === 'active' ? green[100] : form.status === 'deleted' ? red[100] : orange[100]}
                color={form.status === 'active' ? green[300] : form.status === 'deleted' ? red[300] : orange[300]}
                display="flex"
                alignItems="center"
                width="max-content"
                borderRadius={1}
                px={2}
                paddingY="2px"
            >
                <Typography variant="body1" fontWeight="bold">
                    {form.status?.toLocaleUpperCase()}
                </Typography>
            </Box>
            <Box display="flex" alignItems="center">
                <Box bgcolor={brand[50]} color={brand[300]} borderRadius={1} px={2} paddingY="4px"><Typography variant="body2" fontWeight="500">{typeof form.submissions === 'number' ? form.submissions : 0} FORMS SUBMITTED</Typography></Box>
                {form.type === 'internal' && <IconButton onClick={(e) => setAnchorEl(e.currentTarget)}>
                    <MoreVert />
                </IconButton>}
                <Menu
                    anchorEl={anchorEl}
                    open={Boolean(anchorEl)}
                    onClose={() => setAnchorEl(null)}
                    anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                    transformOrigin={{ vertical: 'top', horizontal: 'right' }}
                >
                    {!form.readOnly && form.type !== 'external' && form.status !== 'deleted' && <MenuItem onClick={editFormHandler}>
                        <Box display="flex" alignItems="center" gap={2}>
                            <EditOutlined fontSize="small" />
                            <Typography variant="body1">
                                Edit
                            </Typography>
                        </Box>
                    </MenuItem>}
                    {!form.readOnly && form.type !== 'external' && form.status !== 'deleted' && <MenuItem onClick={handleDuplicateForm}>
                        <Box display="flex" alignItems="center" gap={2}>
                            <FilterNoneOutlined fontSize="small" />
                            <Typography variant="body1">
                                Duplicate
                            </Typography>
                        </Box>
                    </MenuItem>}
                    {!form.readOnly && form.status !== 'deleted' && currentUser?.role !== 'client' && <MenuItem onClick={handleDeleteForm}>
                        <Box display="flex" alignItems="center" gap={2}>
                            <DeleteOutline fontSize="small" />
                            <Typography variant="body1">
                                Delete
                            </Typography>
                        </Box>
                    </MenuItem>}
                    {
                        form.status === 'active' && form.type !== 'external' && <MenuItem onClick={handleShareForm}>
                            <Box display="flex" alignItems="center" gap={2}>
                                <ShareOutlined fontSize="small" />
                                <Typography variant="body1">
                                    Share
                                </Typography>
                            </Box>
                        </MenuItem>
                    }
                </Menu>
            </Box>
        </Box>
        <Box display="flex" justifyContent="space-between" alignItems="center">
            <Typography variant="h5" color={brand[300]} my={1} sx={{ cursor: 'pointer' }} onClick={onClickFormDetail}>{form.title}</Typography>
            {form.type === 'external' && <Box display="flex" alignItems="center" gap={1}>
                <Avatar src={ImageClass.facebookLogo} alt="Facebook Logo" sx={{ height: 25, width: 25 }} />
                <Typography sx={{ cursor: 'pointer' }} variant="body2" fontWeight="600" color={brand[300]}>[External Form]</Typography>
            </Box>}
        </Box>
        <Divider />
        <Box display="flex" justifyContent="space-between" alignItems="center" mt={1}>
            <Box>
                <Typography variant="subtitle2" color="textDisabled">Created On:</Typography>
                <Typography variant="subtitle2" color="textSecondary">{formatDateWithTime(form.created_at)}</Typography>
            </Box>
            <Box>
                <Typography variant="subtitle2" color="textDisabled">Edited On:</Typography>
                <Typography variant="subtitle2" color="textSecondary">{formatDateWithTime(form.updated_at)}</Typography>
            </Box>
        </Box>
        {showDeleteModal && <DeleteFormModal open={showDeleteModal} onClose={() => setShowDeleteModal(false)} />}
        {showShareModal && <ShareFormModal open={showShareModal} onClose={() => setShowShareModal(false)} />}
    </CardWrapper>;
};

export default FormCardItemComponent;